module.exports = __webpack_public_path__ + "img/2.0c6f3f46.png";